module.exports = __webpack_public_path__ + "static/img/2023_9_8_11.08e91856.b367e94.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/2023_9_8_11.08e91856.png
// module id = nIFj
// module chunks = 0